import { defineView } from "@/ReactSetup/view-definitions";

const definition = defineView({
    name: "Iframe",
    component: () => (__SERVER__ ? require("./iframe-view") : import("./iframe-view"))
});

export default definition;
